import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import getIconsAction from "../actions/get-icons.actions";
import { customerPortal } from "@vilocnv/allsetra-core";

type IconState = customerPortal.icons.IconState;

const getIconsCases = (builder: ActionReducerMapBuilder<IconState>) => {
  builder.addCase(getIconsAction.pending, (state) => {
    state.isLoadingIcons = true;
  });
  builder.addCase(getIconsAction.fulfilled, (state, action) => {
    state.icons = action.payload || [];
    state.isLoadingIcons = false;
  });
  builder.addCase(getIconsAction.rejected, (state) => {
    state.isLoadingIcons = false;
  });
};

export default getIconsCases;
